import DateInput from "@/components/Common/DateInput/DateInput.vue";
import TimeInput from "@/components/Common/TimeInput/TimeInput.vue";
import { snowTextureItems } from "@/configuration/formConfigurations";

export default {
  components: { DateInput, TimeInput },
  props: ["editedItem", "isOwnedBySubPrincipal"],
  data: () => ({
    stateItems: [
      { id: "", title: "Keine Angabe" },
      { id: "open", title: "Geöffnet" },
      { id: "closed", title: "Geschlossen" },
      { id: "avalancheLock", title: "Lawinensperrung" },
      { id: "openingHours", title: "Gemäß Öffnungszeiten" }
    ],
    difficultyItems: [
      { id: "easy", title: "Leicht" },
      { id: "intermediate", title: "Mittel" },
      { id: "hard", title: "Schwer" }
    ],
    snowTextureItems,
    floodLightItems: [
      { id: "mo", title: "Montag" },
      { id: "tu", title: "Dienstag" },
      { id: "we", title: "Mittwoch" },
      { id: "th", title: "Donnerstag" },
      { id: "fr", title: "Freitag" },
      { id: "sa", title: "Samstag" },
      { id: "su", title: "Sonntag" }
    ]
  }),
  inject: ["sharedState"],
  mounted() {
    this.sharedState.stateItems = this.stateItems;
  }
};
